import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized Resilience Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing resilience data, error, loading state, contributors, and current level
 *
 */
export const useOptimizedResilience = () => {
  const { error, loading, resilience } = useOuraData();

  return {
    contributors: resilience?.contributors ?? null,
    currentLevel: resilience?.level ?? "unknown",
    error,
    loading,
    resilience,
  };
};
